import CryptoJS from 'crypto-js';

// Function to verify BSNR and create authenticated session
export const verifyBsnr = async (bsnr) => {
  try {
    console.log('Authenticating with BSNR:', bsnr);
    
    // Call the authentication endpoint
    const response = await fetch('/api/auth/verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ bsnr }),
      credentials: 'include' // Important for cookies
    });
    
    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Authentication error: ${error}`);
    }
    
    const result = await response.json();
    
    if (result.authenticated) {
      // Store CSRF token in localStorage for use with subsequent requests
      if (result.csrfToken) {
        localStorage.setItem('csrfToken', result.csrfToken);
      }
      
      // Store the authenticated BSNR for use with the WASM module
      localStorage.setItem('authenticatedBsnr', bsnr);
    }
    
    return result.authenticated;
  } catch (error) {
    console.error('Error during authentication:', error);
    throw error;
  }
};

// Check if user is authenticated via session
export const checkAuthentication = async () => {
  try {
    const response = await fetch('/api/auth/status', {
      credentials: 'include',
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      console.error('Authentication status check failed:', response.statusText);
      return false;
    }
    
    const data = await response.json();
    return data.authenticated === true;
  } catch (error) {
    console.error('Error checking authentication status:', error);
    return false;
  }
};

// Log out and destroy the session
export const logout = async () => {
  try {
    const csrfToken = localStorage.getItem('csrfToken');
    
    const response = await fetch('/api/auth/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken || ''
      },
      credentials: 'include'
    });
    
    localStorage.removeItem('csrfToken');
    localStorage.removeItem('authenticatedBsnr');
    
    return response.ok;
  } catch (error) {
    console.error('Error during logout:', error);
    return false;
  }
};

// Get the authenticated BSNR
export const getAuthenticatedBsnr = () => {
  return sessionStorage.getItem('authenticated_bsnr');
};

// Create a utility function to get CSRF token for protected API calls
export const getCSRFToken = () => {
  return localStorage.getItem('csrfToken') || '';
};

// Utility function for admin to generate hash for a BSNR
export const generateBsnrHash = (bsnr) => {
  // Generate a random salt
  const salt = CryptoJS.lib.WordArray.random(16).toString();
  
  // Create hash with salt
  const hash = CryptoJS.SHA256(bsnr + salt).toString();
  
  return { hash, salt };
};
